import { render, staticRenderFns } from "./myCausally.vue?vue&type=template&id=6e47a1d3&scoped=true&"
import script from "./myCausally.vue?vue&type=script&lang=js&"
export * from "./myCausally.vue?vue&type=script&lang=js&"
import style0 from "./myCausally.vue?vue&type=style&index=0&id=6e47a1d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e47a1d3",
  null
  
)

export default component.exports